<div *ngIf="showComp();" class="popup-data">
  <img class=" connector" src="{{activeUrl}}/{{activeType}}/{{activeComponent}}.jpg" alt="Connector ghost view">
</div>